import { Card, Col, Input, Modal, notification, Row, TreeSelect } from "antd";
import { useEffect, useState } from "react";
import { ColorPalette } from "../share/color/colorPalette";
import TextArea from "antd/es/input/TextArea";
import { useLocation, useNavigate } from "react-router-dom";
import Table, { ColumnsType } from "antd/es/table";
import CustomButton from "../share/customButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  GetAllCitiesByProvinceId,
  GetAllProvinces,
} from "../../services/ProvinceService";
import convertToFlatTreeSelectData from "../../helpers/Convertors/ConvertToFlatTree";
import toast from "react-hot-toast";
import {
  AddAddressService,
  GetMyCompanyAddresses,
} from "../../services/AddressService";

const AddAddress = () => {
  const convertToTreeData = (data: any) => {
    return [
      ...data.map((item: any) => ({
        title: item.localizedName,
        value: item.id,
      })),
    ];
  };

  const navigate = useNavigate();
  const [getNewAddressDialog, SetNewAddressDialog] = useState(false);
  const location = useLocation();
  const searchParams = location.search;

  const isAddPresent = searchParams.includes("Add");

  const formik = useFormik({
    initialValues: {
      title: "",
      addressText: "",
      pelak: "",
      unit: "",
      description: "",
      cityId: "",
    },
    validationSchema: Yup.object().shape({
      title: Yup.string().required("لطفا عنوان آدرس را وارد کنید"),
      cityId: Yup.string().required("لطفا شهر را انتخاب کنید"),
      pelak: Yup.number()
        .typeError("لطفاً برای پلاک فقط عدد وارد کنید")
        .required("لطفا پلاک را وارد کنید"),
      unit: Yup.number()
        .typeError("لطفاً برای واحد فقط عدد وارد کنید")
        .required("لطفا واحد را وارد کنید"),

      addressText: Yup.string().required("لطفا متن کامل آدرس را وارد کنید"),
    }),
    onSubmit: (values) => {
      AddAddressService(values).then((p) => {
        if (p.status === 200) {
          toast.success("با موفقیت ثبت");
          LoadData();
          navigate("/CompanyInfo?tab=7");
        } else {
        }
      });
    },
  });

  const columnsTotal: ColumnsType<any> = [
    {
      title: "عنوان",
      dataIndex: "title",
      key: "title",
      width: "20%",
    },
    {
      title: "آدرس کامل",
      dataIndex: "addressText",
      key: "addressText",
      width: "25%",
    },
    {
      title: "پلاک",
      dataIndex: "pelak",
      key: "pelak",
      width: "5%",
    },
    {
      title: "واحد",
      dataIndex: "unit",
      key: "unit",
      width: "5%",
    },
    {
      title: "توضیحات",
      dataIndex: "description",
      key: "description",
      width: "5%",
    },
  ];
  const [data, setData] = useState<any>([]);

  const [provinces, SetProvinces] = useState<any>([]);
  const [getSelectedProvinces, setSelectedProvinces] = useState(null);

  const [cities, SetCities] = useState<any>([]);
  const [getSelectedCity, setSelectedCity] = useState(null);

  const LoadData = () => {
    GetMyCompanyAddresses().then((p) => {
      setData(p?.data?.data);
    });
  };
  useEffect(() => {
    LoadData();
    GetAllProvinces().then((p) => {
      SetProvinces(convertToTreeData(p.data.data));
    });
  }, []);
  useEffect(() => {
    if (getSelectedProvinces) {
      GetAllCitiesByProvinceId(getSelectedProvinces).then((p) => {
        SetCities(convertToTreeData(p.data.data));
      });
    }
  }, [getSelectedProvinces]);
  useEffect(() => {
    if (getSelectedCity) {
      formik.setFieldValue("cityId", getSelectedCity);
    }
  }, [getSelectedCity]);

  return (
    <>
      <Row style={{ width: "100%", marginTop: "16px" }}>
        <Table
          style={{ margin: "auto", width: "100%" }}
          columns={columnsTotal}
          dataSource={data}
          pagination={false}
        />
      </Row>
      <Modal
        open={getNewAddressDialog || isAddPresent}
        footer={null}
        width={900}
        onCancel={() => navigate("/CompanyInfo?tab=7")}
      >
        <Card className="mt-3" style={{ width: "50rem", margin: "auto" }}>
          <Row className="display-flex align-items-center my-2 mt-2">
            <Col style={{ margin: "auto" }}>
              <Row style={{ height: "37px" }}>
                <Col
                  style={{
                    fontFamily: "YekanBakhVF",
                    fontWeight: "325",
                    fontSize: "16px",
                    lineHeight: "28.8px",
                    color: ColorPalette.gray[950],
                  }}
                >
                  عنوان آدرس{" "}
                </Col>
              </Row>
              <Row>
                <Col>
                  <Input
                    {...formik.getFieldProps("title")}
                    style={{ width: "45.3rem", height: "40px" }}
                    id="title"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="display-flex align-items-center my-2 mt-2">
            <Col style={{ margin: "auto" }}>
              <Row style={{ height: "37px" }}>
                <Col
                  style={{
                    fontFamily: "YekanBakhVF",
                    fontWeight: "325",
                    fontSize: "16px",
                    lineHeight: "28.8px",
                    color: ColorPalette.gray[950],
                  }}
                >
                  استان{" "}
                </Col>
              </Row>
              <Row>
                <Col>
                  <Col>
                    <TreeSelect
                      showSearch
                      style={{ width: "22rem", height: "40px" }}
                      value={getSelectedProvinces}
                      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                      placeholder="استان مورد نظر را انتخاب کنید"
                      onChange={(e) => {
                        setSelectedProvinces(e);
                      }}
                      treeData={provinces}
                      filterTreeNode={(input: any, node: any) =>
                        node.title.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Col>
                </Col>
              </Row>
            </Col>
            <Col style={{ margin: "auto" }}>
              <Row style={{ height: "37px" }}>
                <Col
                  style={{
                    fontFamily: "YekanBakhVF",
                    fontWeight: "325",
                    fontSize: "16px",
                    lineHeight: "28.8px",
                    color: ColorPalette.gray[950],
                  }}
                >
                  شهر{" "}
                </Col>
              </Row>
              <Row>
                <Col>
                  <TreeSelect
                    disabled={cities.length <= 0}
                    showSearch
                    style={{ width: "22rem", height: "40px" }}
                    value={getSelectedCity}
                    dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                    placeholder="شهر مورد نظر را انتخاب کنید"
                    //allowClear
                    //treeDefaultExpandAll
                    onChange={async (e) => {
                      setSelectedCity(e);
                    }}
                    treeData={cities}
                    filterTreeNode={(input: any, node: any) =>
                      node.title.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                  {/* <Select
                          //onChange={handleChange}

                          defaultValue="1"
                          id="unit"
                          value={"انتخاب کنید"}
                          onChange={(e) =>
                            SetUnSavedNoticeDetailsInfo({
                              target: { id: "unit", value: e },
                            })
                          }
                        /> */}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="display-flex align-items-center my-2 mt-2">
            <Col style={{ margin: "auto" }}>
              <Row style={{ height: "37px" }}>
                <Col
                  style={{
                    fontFamily: "YekanBakhVF",
                    fontWeight: "325",
                    fontSize: "16px",
                    lineHeight: "28.8px",
                    color: ColorPalette.gray[950],
                  }}
                >
                  پلاک{" "}
                </Col>
              </Row>
              <Row>
                <Col>
                  <Input
                    {...formik.getFieldProps("pelak")}
                    style={{ width: "22rem", height: "40px" }}
                    id="pelak"
                  />
                </Col>
              </Row>
            </Col>

            <Col style={{ margin: "auto" }}>
              <Row style={{ height: "37px" }}>
                <Col
                  style={{
                    fontFamily: "YekanBakhVF",
                    fontWeight: "325",
                    fontSize: "16px",
                    lineHeight: "28.8px",
                    color: ColorPalette.gray[950],
                  }}
                >
                  واحد{" "}
                </Col>
              </Row>
              <Row>
                <Col>
                  <Input
                    {...formik.getFieldProps("unit")}
                    style={{ width: "22rem", height: "40px" }}
                    id="unit"
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Row style={{ marginTop: "16px" }}>
            <Col style={{ margin: "auto" }}>
              <Row style={{ height: "37px" }}>
                <Col
                  style={{
                    fontFamily: "YekanBakhVF",
                    fontWeight: "325",
                    fontSize: "16px",
                    lineHeight: "28.8px",
                    color: ColorPalette.gray[950],
                  }}
                >
                  آدرس کامل
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextArea
                    {...formik.getFieldProps("addressText")}
                    style={{
                      height: "92px",
                      width: "45.5rem",
                    }}
                    id="addressText"
                    rows={6}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row style={{ marginTop: "16px" }}>
            <Col style={{ margin: "auto" }}>
              <Row style={{ height: "37px" }}>
                <Col
                  style={{
                    fontFamily: "YekanBakhVF",
                    fontWeight: "325",
                    fontSize: "16px",
                    lineHeight: "28.8px",
                    color: ColorPalette.gray[950],
                  }}
                >
                  توضیحات
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextArea
                    {...formik.getFieldProps("description")}
                    style={{
                      height: "92px",
                      width: "45.5rem",
                    }}
                    id="description"
                    rows={6}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="mt-4" dir="ltr">
            <Col>
              <CustomButton
                onClick={() => {
                  if (Object.keys(formik.errors).length > 0) {
                    // console.log(formik.errors);
                    const firstErrorMessage = Object.values(formik.errors)[0];
                    toast.error(firstErrorMessage);
                  } else {
                    formik.submitForm();
                  }
                }}
                customType="Primary"
                hasTitle
                customSize="XLarge"
                style={{ width: "152px", marginLeft: "8px" }}
              >
                افزودن آدرس جدید
              </CustomButton>
            </Col>
          </Row>
        </Card>
      </Modal>
    </>
  );
};

export default AddAddress;
